<form [formGroup]="thirdPartyUserEditForm">
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="password" class="control-label" [ngClass]="{'required': isAdd}">{{ "i18n.shared.fields.new-password" |
        translate }}</label>
      <input id="password" type="password" autocomplete="new-password" class="form-control" formControlName="password"
        appPasswordVisibility>
      <app-error-messages [control]="thirdPartyUserEditForm.controls.password"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="userName" class="control-label" [ngClass]="{'required': isAdd}">{{ 'i18n.base.user-add-modal.userName' | translate }}</label>
      <input id="userName" type="text" class="form-control" formControlName="userName" />
      <app-error-messages [control]="thirdPartyUserEditForm.controls.userName"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12" *ngIf="!hideClient()">
      <label for="client" class="control-label">{{
        'i18n.base.user-management.column-headers.client' | translate }}</label>
      <app-client-autocomplete class="client-autocomplete" formControlName="client"
        placeholder=""></app-client-autocomplete>
    </div>
  </div>
  <div class="form-row row" *ngIf="!isAdd && !isLoggedInUser">
    <div class="form-group col-md-12">
      <label for="enabled" class="d-block">{{ 'i18n.base.user-add-modal.enabled' | translate }}</label>
      <app-yes-no-group-button id="enabled" formControlName="enabled"></app-yes-no-group-button>
    </div>
  </div>
</form>
